import React from 'react'

import { Button } from '@interco/inter-ui/components/Button'
import { Signal } from '@interco/inter-ui/components/Signal'
import IcWarningCircle from '@interco/icons/core/status/ic_warning_circle'
import IcClose from '@interco/icons/core/action-navigation/ic_close'
import BaseService from '@/services/BaseService'
import Page from '@/components/templates/Page'
import Paragraph from '@/components/atoms/Paragraph'
import { Colors } from '@/utils'

import { Container, ButtonWrapper, CloseButton } from './MinorAgeRestriction.styles'

const MinorAgeRestriction: React.FC = () => {
  const handleClose = async () => {
    await BaseService.goBack()
  }

  return (
    <Page
      footer={
        <ButtonWrapper>
          <Button variant="primary" onClick={handleClose} fullWidth>
            Voltar pra Home
          </Button>
        </ButtonWrapper>
      }
    >
      <CloseButton onClick={handleClose} aria-label="Fechar" data-testid="close-icon">
        <IcClose height={24} width={24} color="var(--gray400)" />
      </CloseButton>

      <Container>
        <Signal icon={IcWarningCircle} color="var(--gray100)" iconColor="var(--gray500)" />

        <Paragraph
          variant="sora"
          fontWeight={600}
          fontSize="20px"
          lineHeight="28px"
          color={Colors.GRAY500}
          textAlign="center"
          margin="24px 0 16px 0"
        >
          Produto indisponível para menores de idade
        </Paragraph>

        <Paragraph
          variant="inter"
          fontWeight={400}
          fontSize="14px"
          lineHeight="20px"
          color={Colors.GRAY400}
          textAlign="center"
          margin="0"
        >
          Este produto é exclusivo para maiores de 18 anos e não pode ser acessado.
        </Paragraph>
      </Container>
    </Page>
  )
}

export default MinorAgeRestriction
